<template>
  <div>
    <v-expansion-panels v-if="(dateien && dateien?.length)||(unterlagen && unterlagen?.length)" class="mt-5">
      <v-expansion-panel v-if="dateien && dateien?.length">
        <v-expansion-panel-title><strong>Dateien</strong></v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-list>
            <v-list-item v-for="file in dateien" :key="file.DownloadToken">

                <ApiDownload
                  :title="file.Dateiname.replaceAll('_', ' ')"
                  :token="file.DownloadToken"
                  :file-name="file.Dateiname"
                />

            </v-list-item>
          </v-list>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="unterlagen && unterlagen?.length">
        <v-expansion-panel-title><strong>Unterlagen</strong></v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-list>
            <v-list-item v-for="item in unterlagen" :key="item.Bezeichnung">

                <v-list-item-title class="mb-2">{{
                  item.Bezeichnung
                }}</v-list-item-title>

                <v-row>
                  <v-col cols="6" v-for="page in item.Seiten" :key="page">
                    <ApiDownload
                      :key="page.Seite"
                      :title="`Seite ${page.Seite}`"
                      :token="page.DownloadToken"
                      :file-name="`${page.Seite.toString()}.jpg`"
                    />
                  </v-col>
                </v-row>

            </v-list-item>
          </v-list>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

  </div>
</template>

<script setup lang="ts">
import ApiDownload from '@/components/ApiDownload.vue';

defineProps({
  dateien: {
    type: Array<any>,
    required: false,
  },
  unterlagen: {
    type: Array<any>,
    required: false,
  },
});

defineExpose({
  ApiDownload,
});

</script>
<style></style>
